import { useTranslation } from 'react-i18next';

import type { CreditNoteStatus } from '~/api/creditNotes/types';
import type { IconName } from '~/components/Icon/Icon';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<CreditNoteStatus, StatusEntry> = {
  InReview: { icon: 'HourglassTop', status: 'warning' },
  Approved: { icon: 'Check', status: 'success' },
};

type Props = {
  status: CreditNoteStatus;
};

export const CreditNoteStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];
  const { t } = useTranslation(['creditnotes']);

  return <StatusTag icon={icon} label={t(`creditnotes:overview.columns.status.options.${status}`)} status={statusTheme} />;
};
